export interface IWatrFraudFlag {
    id?: number,
    type: number,
    requestId: number,
    description: string,
    relatedRequestId?: number,
    relatedDonorAlias: string,
    createdDate: Date,
    createdByUserId: number,
    updatedDate: Date,
    updatedByUserId:number
}